<template>
  <div>
    <div v-for="field in fields" :key="field.key">
      <template v-if="field.type === 'reference'">
        {{ getReferenceValue(field, value[field.key]) }}
      </template>
      <template v-else-if="field.type === 'list'">
        {{ getListValue(field, value[field.key]) }}
      </template>
      <template v-else-if="field.type === 'date'">
        {{ formatDate(value[field.key]) }}
      </template>
      <template v-else-if="field.type === 'datetime'">
        {{ formatDateTime(value[field.key]) }}
      </template>
      <template v-else-if="field.type === 'boolean'">
        {{ value[field.key] ? "YES" : "NO" }}
      </template>
      <template v-else>
        {{ value[field.key] }}
      </template>
    </div>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "ViewGroupField",
  props: {
    fields: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    lists: {
      type: Array,
      default: () => [],
    },
    models: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      referenceOptions: {},
    };
  },
  mounted() {
    this.loadReferenceOptions();
  },
  methods: {
    async loadReferenceOptions() {
      for (const field of this.fields) {
        if (field.type === "reference" && field.ref) {
          try {
            const { data } = await wencesApi.get(
              `/api/gotrading/dynamic/${field.ref}`
            );
            this.$set(this.referenceOptions, field.key, data);
          } catch (error) {
            console.error(
              `Error loading reference options for ${field.key}:`,
              error
            );
            this.$set(this.referenceOptions, field.key, []);
          }
        }
      }
    },
    getReferenceValue(field, value) {
      if (!value) return "";

      const refOptions = this.referenceOptions[field.key];
      if (!refOptions) return value;

      // Si el valor es un objeto con _id
      if (typeof value === "object" && value._id) {
        const refItem = refOptions.find((item) => item._id === value._id);
        return refItem
          ? refItem.name || refItem.label || refItem._id
          : value._id;
      }

      // Si el valor es un string (el _id)
      if (typeof value === "string") {
        const refItem = refOptions.find((item) => item._id === value);
        return refItem ? refItem.name || refItem.label || refItem._id : value;
      }

      return value;
    },
    getListValue(field, value) {
      if (!value) return "";

      // Si es una lista múltiple
      if (field.isArray && Array.isArray(value)) {
        return value.map((v) => this.getListOptionLabel(field, v)).join(", ");
      }

      // Si es una lista simple
      return this.getListOptionLabel(field, value);
    },
    getListOptionLabel(field, value) {
      if (!value) return "";

      // Si el valor es un objeto con _id, usar el _id
      const id = typeof value === "object" && value._id ? value._id : value;

      // Buscar en los listados disponibles
      const list = this.lists?.find((l) => l.type === field.listType);
      if (!list || !list.values) return id;

      // Buscar el valor en la lista
      const option = list.values.find((opt) => opt._id === id);
      return option ? option.label : id;
    },
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString();
    },
    formatDateTime(value) {
      if (!value) return "";
      return new Date(value).toLocaleString();
    },
  },
};
</script>
